// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "../../../../../wp-content/themes/skapia/app/dist/css/" + chunkId + "." + {"478":"201c17e9","559":"af317a54","853":"968418a3"}[chunkId] + ".css";
};